import { MODE } from '@/define/robotStatus';
import EventEmitter from '@/libs/EventEmitter';

export const executeMavLinkCommand = (robot, commandFactory) => {
  return new Promise((resolve, reject) => {
    const commandConfig = commandFactory(robot);
    const { execute, topic, topics, isMatch = () => true, isSuccess = () => true } = commandConfig;

    const topicsToSubscribe = topics || [topic];
    const tokens = [];

    topicsToSubscribe.forEach((topic) => {
      const token = EventEmitter.subscribe(topic, (data) => {
        if (!isMatch(data)) return;

        tokens.forEach((token) => EventEmitter.unsubscribe(token));
        clearTimeout(timer);

        if (isSuccess(data)) {
          resolve(data);
        } else {
          reject(data);
        }
      });

      tokens.push(token);
    });

    const timer = setTimeout(() => {
      tokens.forEach((token) => EventEmitter.unsubscribe(token));
      reject();
    }, 5000);

    execute();
  });
};

export const executeDJICommand = (robot, commandFactory) => {
  return new Promise((resolve, reject) => {
    const commandConfig = commandFactory(robot);
    const { execute, topic, isMatch = () => true, isSuccess = () => true } = commandConfig;

    const token = EventEmitter.subscribe(topic, (data) => {
      if (!isMatch(data)) return;

      EventEmitter.unsubscribe(token);
      clearTimeout(timer);

      if (isSuccess(data)) {
        resolve(data);
      } else {
        reject(data);
      }
    });

    const timer = setTimeout(() => {
      EventEmitter.unsubscribe(token);
      reject();
    }, 5000);

    execute();
  });
};

export const getModeId = (vehicle, mode = 'GUIDED') => {
  const modeMapping = {
    Copter: MODE.ARDUPILOT.COPTER[mode].id,
    Plane: MODE.ARDUPILOT.PLANE[mode].id,
    Rover: MODE.ARDUPILOT.ROVER[mode].id,
  };

  return modeMapping[vehicle];
};
